import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateCSS } from 'shared/utils/update-css';
import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import WixSDK from 'shared/utils/wix-sdk';

import { updateAppSettings, fetchAppSettings } from 'widget/redux/client/actions/app-settings';

import DataComponent from 'shared/data-components/_data-component';


@connect(null, {
  updateAppSettings,
  fetchAppSettings,
})
export default class AppSettingsLoader extends DataComponent {

  static displayName = 'AppSettingsLoader';
  static propTypes = {
    updateAppSettings: PropTypes.func,
  };

  @autobind
  @debounce
  handleEditModeChanging({ editMode }) {
    this.props.updateAppSettings({ editMode });
  }

  @autobind
  @debounce
  handleSettingsChanging(styleParams) {
    updateCSS(styleParams);
    this.props.updateAppSettings(styleParams);
  }

  componentDidMount() {
    this.props.fetchAppSettings()
      .then(() => {
        WixSDK.addEventListener(WixSDK.Events.STYLE_PARAMS_CHANGE, this.handleSettingsChanging);
        WixSDK.addEventListener(WixSDK.Events.EDIT_MODE_CHANGE, this.handleEditModeChanging);
      });
  }

  componentWillUnmount() {
    WixSDK.removeEventListener(WixSDK.Events.STYLE_PARAMS_CHANGE, this.handleSettingsChanging);
    WixSDK.removeEventListener(WixSDK.Events.EDIT_MODE_CHANGE, this.handleEditModeChanging);
  }

  get childProps() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/app-settings.js